import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AgentDesktop } from "@/components/desktop/agent-desktop";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/sonner";
import { initHostHandshake } from "@/iframe/hostHandshake";
import { initializeIframeSession } from "@/iframe/session";
import "./index.css";

initHostHandshake();
initializeIframeSession();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <TooltipProvider>
      <AgentDesktop />
      <Toaster position="bottom-right" />
    </TooltipProvider>
  </StrictMode>,
);
